var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "el-tree-select", class: _vm.selectClass },
    [
      _c(
        "el-select",
        _vm._b(
          {
            directives: [
              { name: "popover", rawName: "v-popover:popover", arg: "popover" },
            ],
            ref: "select",
            staticClass: "el-tree-select-input",
            style: _vm.styles,
            attrs: {
              id: "el-tree-select-" + _vm.guid,
              "collapse-tags": _vm.showNumber,
              disabled: _vm.disabled,
              "popper-class": "de-select-option",
              "popper-append-to-body": _vm.popperAppendToBody,
              filterable: false,
              multiple: _vm.selectParams.multiple,
              title: _vm.labels,
            },
            on: {
              "remove-tag": _vm._selectRemoveTag,
              clear: _vm._selectClearFun,
              focus: _vm._popoverShowFun,
            },
            model: {
              value: _vm.labels,
              callback: function ($$v) {
                _vm.labels = $$v
              },
              expression: "labels",
            },
          },
          "el-select",
          _vm.selectParams,
          false
        )
      ),
      _c(
        "el-popover",
        {
          ref: "popover",
          attrs: {
            "append-to-body": _vm.popperAppendToBody,
            placement: _vm.placement,
            transition: _vm.transition,
            "popper-class": _vm.popperClass,
            width: _vm.width,
            trigger: "click",
          },
          on: { show: _vm.showPopover },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _vm.treeParams.filterable
            ? _c(
                "el-input",
                {
                  ref: "input",
                  staticClass: "input-with-select mb10",
                  attrs: { size: "mini" },
                  model: {
                    value: _vm.keywords,
                    callback: function ($$v) {
                      _vm.keywords = $$v
                    },
                    expression: "keywords",
                  },
                },
                [
                  _c("el-button", {
                    attrs: { slot: "append", icon: "el-icon-search" },
                    on: { click: _vm._searchFun },
                    slot: "append",
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.selectParams.multiple
            ? _c(
                "p",
                { staticClass: "tree-select-all" },
                [
                  _c(
                    "el-checkbox",
                    {
                      directives: [
                        {
                          name: "customStyle",
                          rawName: "v-customStyle",
                          value: _vm.customStyle,
                          expression: "customStyle",
                        },
                      ],
                      attrs: { indeterminate: _vm.isIndeterminate },
                      on: { change: _vm.selectAllChange },
                      model: {
                        value: _vm.selectAll,
                        callback: function ($$v) {
                          _vm.selectAll = $$v
                        },
                        expression: "selectAll",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("dataset.check_all")))]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-scrollbar",
            {
              staticClass: "is-empty",
              attrs: {
                tag: "div",
                "wrap-class": "el-select-dropdown__wrap",
                "view-class": "el-select-dropdown__list",
              },
            },
            [
              _c(
                "el-tree",
                _vm._b(
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.data.length > 0,
                        expression: "data.length > 0",
                      },
                    ],
                    ref: "tree",
                    attrs: {
                      "popper-append-to-body": _vm.popperAppendToBody,
                      data: _vm.data,
                      "node-key": _vm.propsValue,
                      draggable: false,
                      "current-node-key": _vm.ids.length > 0 ? _vm.ids[0] : "",
                      "show-checkbox": _vm.selectParams.multiple,
                      "filter-node-method": _vm.filterNodeMethod
                        ? _vm.filterNodeMethod
                        : _vm._filterFun,
                      "render-content": _vm.treeRenderFun,
                    },
                    on: {
                      "node-click": _vm._treeNodeClickFun,
                      check: _vm._treeCheckFun,
                      "check-change": _vm._treeCheckChange,
                    },
                  },
                  "el-tree",
                  _vm.treeParams,
                  false
                )
              ),
              _vm.data.length === 0
                ? _c("div", { staticClass: "no-data" }, [_vm._v("暂无数据")])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }